import cx from 'classnames';
import type { SyntheticEvent } from 'react';
import { forwardRef } from 'react';

import Icon from '../../../Icon';

interface Props {
  className?: string;
  isDragging?: boolean;
  isResizing?: boolean;
}

const DragHandle = forwardRef<HTMLDivElement, Props>((props, forwardedRef) => {
  const { isDragging, className, isResizing } = props;
  const classNames: string = cx(
    'text-grey-base',
    {
      'cursor-grab': !isDragging,
      'cursor-grabbing': isDragging,
      'pointer-events-none': isResizing
    },
    className
  );

  const handleClick = (event: SyntheticEvent): void => event.stopPropagation();

  return (
    <div
      ref={forwardedRef}
      className={classNames}
      data-component="table-drag-handle"
      data-testid="drag-handle"
      onClick={handleClick}
    >
      <Icon icon="zicon-drag-handle" />
    </div>
  );
});

export default DragHandle;
